require("./packages/title_notifier");

window.axios = require("axios");

window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    axios.defaults.headers.common["X-CSRF-TOKEN"] = token.content;
} else {
    console.error(
        "CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token"
    );
}

window.canPing = true;
window.isConnected = false;
window.isDocVisible = !document.hidden;
window.isDocFocus = document.hasFocus();

titlenotifier.max(99);
/*titlenotifier.reset();
titlenotifier.set(0);
titlenotifier.add();
titlenotifier.sub();
titlenotifier.get();
titlenotifier.add();*/

window.updatetitleNotifier = function () {
    titlenotifier.set(
        window.chatbot_unread_messages +
            window.messenger_unread_messages +
            window.unread_notifications
    );
};
updatetitleNotifier();

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

import Echo from "laravel-echo";
window.Pusher = require("pusher-js");

window.Echo = new Echo({
    broadcaster: "pusher",
    key: window.pusher_key,
    cluster: window.pusher_cluster,
    forceTLS: true,
    //wsHost: window.location.hostname,
    //wsPort: 6001,
    //enabledTransports: ['ws'] // <- added this param
});

window.LaravelSurvivor = {
    token: token.content,
    interval: setInterval(function () {
        window.LaravelSurvivor.ping();
    }, 900000),
    ping: function () {
        if (!window.canPing) return;
        window.canPing = false;

        axios
            .get("/ping", null, {
                headers: {
                    "X-Requested-With": "XMLHttpRequest",
                    "X-CSRF-TOKEN": window.LaravelSurvivor.token,
                },
            })
            .then((response) => {
                if (response && response._token) {
                    window.LaravelSurvivor.token = response._token;
                    var meta = document.querySelectorAll(
                        "meta[name=csrf-token]"
                    );
                    var inputs =
                        document.querySelectorAll("input[name=_token]");

                    axios.defaults.headers.common["X-CSRF-TOKEN"] =
                        response._token;

                    if (meta) {
                        meta[0].setAttribute("content", response._token);
                    }

                    if (inputs) {
                        for (var i = 0; i < inputs.length; i++) {
                            inputs[i].value = response._token;
                        }
                    }
                }
                window.isConnected = true;
            })
            .catch(function (error) {})
            .then(function () {
                setTimeout(() => {
                    window.canPing = true;
                }, 5000);
            });
    },
};

window.Echo.connector.pusher.connection.bind("connecting", (payload) => {
    //console.log("ping connecting...");
    window.LaravelSurvivor.ping();
});

window.Echo.connector.pusher.connection.bind("connected", (payload) => {
    //console.log("ping connected...");
    window.LaravelSurvivor.ping();
    //console.log('connected!', payload);
});

window.Echo.connector.pusher.connection.bind("disconnected", (payload) => {
    //console.log('disconnected', payload);
    //console.log("ping disconnected...");
    window.LaravelSurvivor.ping();
    window.isConnected = false;
});

window.Echo.connector.pusher.connection.bind("message", (payload) => {
    //console.log('message', payload);
});

window.Echo.connector.pusher.connection.bind("state_change", (states) => {
    window.LaravelSurvivor.ping();
    //console.log("ping state_change...");
    // states = {previous: 'oldState', current: 'newState'}
    //console.log('oldState ', states.previous);
    //console.log('newState ', states.current);
});

function visibilitychange(event) {
    window.isDocVisible = !document.hidden;
    window.LaravelSurvivor.ping();
    //console.log("ping visibilitychange...");
    if (!window.isDocVisible) {
        //console.log('not visible');
    } else {
        //console.log('is visible');
    }
    window.isDocFocus = document.hasFocus();
    if (!window.isDocFocus) {
        //console.log('not Focus');
    } else {
        //console.log('is Focus');
    }
}
document.addEventListener("visibilitychange", visibilitychange);
document.addEventListener("mozvisibilitychange", visibilitychange);
document.addEventListener("webkitvisibilitychange", visibilitychange);
document.addEventListener("msvisibilitychange", visibilitychange);
window.addEventListener("blur", visibilitychange);
window.addEventListener("focus", visibilitychange);

window.ensureIsConnected = function (timeout) {
    var start = Date.now();
    return new Promise(waitForFoo); // set the promise object within the ensureFooIsSet object

    // waitForFoo makes the decision whether the condition is met
    // or not met or the timeout has been exceeded which means
    // this promise will be rejected
    function waitForFoo(resolve, reject) {
        if (window && window.isConnected) resolve(window.isConnected);
        else if (timeout && Date.now() - start >= timeout)
            reject(new Error("timeout"));
        else setTimeout(waitForFoo.bind(this, resolve, reject), 30);
    }
};
